import React from 'react';
import ReportingDonationsPage from '../components/ReportingDonationsPage';

const ReportingDonationsApp = (props) => (
  <ReportingDonationsPage {...props} />
);

export default ReportingDonationsApp;
